import tx from "@/core/app/tx";

const items = [
    {id:""         , nameTx:''          , name: ''                 },
    {id:"itv"      , nameTx:'ITV'       , name: 'ITV'              },
    {id:"itv 2"    , nameTx:'ITV 2'     , name: 'ITV 2'            },
    {id:"wash"     , nameTx:"Wash"      , name: "Wash"             },
    {id:"plate"    , nameTx:"Plate"     , name: "Plate"            },
    {id:"battery"  , nameTx:"battery"   , name: "battery"          },
    {id:"mechanic" , nameTx:"Mechanic"  , name: "Mechanic"         },
    {id:"other"    , nameTx:"Other"     , name: "Other"            },
];

const values = Object.freeze ({
    NONE      : ""         ,
    ITV       : "itv"      ,
    ITV_2     : "itv 2"    ,
    WASH      : "wash"     ,
    PLATE     : "plate"    ,
    BATTERY   : "battery"  ,
    MECHANIC  : "mechanic" ,
    OTHER     : "other"    ,
});

function getName(status) {
    switch(status) {

        case "itv"       : return  items[1].name;
        case "itv 2"     : return  items[2].name;
        case "wash"      : return  items[3].name;
        case "plate"     : return  items[4].name;
        case "battery"   : return  items[5].name;
        case "mechanic"  : return  items[6].name;
        case "other"     : return  items[7].name;

        default: return status;
    }
}

function translateNames() {
    for (let item of items) {
        item.name = tx.t(item.nameTx);
    }
}
/*

function translateNamesForList() {
    for (let item of itemsForList) {
        item.name = tx.t(item.nameTx);
    }
}*/

function getItems() { return items }

//function getItemsForList(){return itemsForList}

export default {
    getItems, getName , translateNames, values  //getItemsForList translateNamesForList
}

